<svg class="svg" width="16" height="16" fill="none" viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg">
    <path
        d="M9.47 6.77 15.3 0h-1.4L8.85 5.88 4.81 0H.15l6.11 8.9L.15 16h1.38l5.35-6.21L11.14 16h4.67L9.47 6.77Zm-1.9 2.2-.61-.88-4.93-7.05h2.12l3.98 5.69.62.88 5.17 7.4h-2.13L7.58 8.97Z"
        fill-rule="nonzero" fill-opacity="1" attr.fill="{{fill}}" stroke="none"></path>
</svg>